import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ReviewPopupKYC from './review-popup';
import DocumentPreview from '../Create-Investment/documentpreview';
import ActivityLog from '../../Components/ActivityLog/activity-log';
import { useSelector } from 'react-redux';
import StatusButton from '../../Components/Onbaording/status-button';
import FileUploadDisplay from '../../Components/Onbaording/file-display';
import MindmapTree from '../../Components/Onbaording/onboarding-tree';
import { useToast } from '../../Utils/toastContext';
import SectionStatusGrid from '../../Components/Onbaording/status-section';
import { debounce } from 'lodash';
// import StatusDropdown from "../../Components/Onbaording/section-status-dropdown";
import EDDModal from '../../Pages/Risk-Assessment/edd-modal';
import UserQuestionnaire from '../../Pages/Risk-Assessment/user-questionnarie';
import AuditStepper from '../../Components/Onbaording/onboarding-stepper';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

// const steps = [
//   {
//     key: 'submitted',
//     label: 'Application Submitted',
//     icon: 'description',
//     status: 'completed',
//   },
//   // {
//   //   key: 'sanction',
//   //   label: 'Sanction Verified',
//   //   icon: 'gavel',
//   //   status: 'completed',
//   // },
//   {
//     key: 'identity',
//     label: 'Identity Verified',
//     icon: 'verified_user',
//     status: 'completed',
//   },
//   {
//     key: 'manual',
//     label: 'Manual Review',
//     icon: 'manage_search',
//     status: 'active',
//   },
//   {
//     key: 'approved',
//     label: 'Approved',
//     icon: 'check_circle',
//     status: 'pending',
//   },
// ];
const ReviewKYCCorporate = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dropdownRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const { customerId } = useParams();
  const [graphData, setGraphData] = useState([]);
  const roleName = useSelector((state) => state.user.roleName);
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [eddResponse, setEddResponse] = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [steps, setSteps] = useState([]);

  const [fileCompanyOrganisationalChart, setFileCompanyOrganisationalChart] =
    useState(null);
  const [fileAccountantCertificate, setFileAccountantCertificate] =
    useState(null);
  const [fileIncorporationCertificate, setFileIncorporationCertificate] =
    useState(null);
  const [fileCertificateOfIncumbency, setFileCertificateOfIncumbency] =
    useState(null);
  const [thpDescription, setThpDescription] = useState('');
  const [fileUboCertificate, setFileUboCertificate] = useState(null);
  const [fileShareholderCertificate, setFileShareholderCertificate] =
    useState(null);
  const [verificationStatus, setVerificationStatus] = useState('');
  const [dvsTime, setDvsTime] = useState('');
  const [dvsMeessage, setDvsMeessage] = useState('');
  const [customerStatus, setCustomerStatus] = useState(null);

  const updateFieldStatus = useSelector(
    (state) => state.form.updateFieldStatus,
  );
  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 4,
      multi_select: 6,
      file: 8,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  const pendingQuestions = mapQuestions(
    (eddResponse?.pending || []).flatMap((item) => item.questions || []),
  );

  const completedQuestions = mapQuestions(
    (eddResponse?.completed || []).flatMap((item) => item.questions || []),
  );
  const completedGroups = (eddResponse?.completed || []).map((item) => ({
    id: item.id,
    requestedBy: item.requested_by?.name,
    respondedAt: item.responded_at,
    questions: mapQuestions(item.questions || []),
  }));
  const [fileProof, setFileProof] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [description, setDescription] = useState('');
  const [companyTypeText, setCompanyTypeText] = useState('');
  const [principalAddress, setPrincipalAddress] = useState('');
  const [stockRegistered, setStockRegistered] = useState('');
  const [stockExchangeText, setStockExchangeText] = useState('');
  const [arbn, setArbn] = useState('');
  const [loading, setLoading] = useState(false);
  const [layers, setLayers] = useState([]);
  const [ticketLink, setTicketLink] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [lastNameSignup, setLastNameSignup] = useState('');
  const [firstNameSignup, setFirstNameSignup] = useState('');
  const [email, setEmail] = useState('');
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState('');
  const [foreignAddress, setForeignAddress] = useState('');

  const [webLink, setWebLink] = useState('');
  const [foreignRegistered, setForeignRegistered] = useState('');
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [fileActivityEvidence, setFileActivityEvidence] = useState(null);
  const [filePublicDocument, setFilePublicDocument] = useState(null);
  const [signatories, setSignatories] = useState([]);
  const [fileTicket, setFileTicket] = useState(null);
  const [DoI, setDoI] = useState('');
  const [EIN, setEIN] = useState('');
  const [stateText, setStateText] = useState('');
  const [acn, setAcn] = useState('');
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [formattedDOI, setFormattedDOI] = useState('');
  const [abn, setAbn] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const [currentDocument, setcurrentDocument] = useState({});
  const [countryCodeText, setCountryCodeText] = useState('Australia');
  const [registeredAddress, setRegisteredAddress] = useState('');
  const [fileArticle, setFileArticle] = useState(null);
  const [collapsedLayers, setCollapsedLayers] = useState({}); // { layerName: true/false }
  const [isOpenAction, setIsOpenAction] = useState(false);
  const [fileAttorney, setFileAttorney] = useState(null);
  const [businessActivity, setBusinessActivity] = useState('smaple text');
  const [preview, setPreview] = useState('');

  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };
  const [members, setMembers] = useState([
    {
      firstName: 'abc',
      dob: 'test',
      email: 'abc@gmail.com',
      countryCode: 'AU(+61)',
      mobile: '7766',
      address: 'street1 2',
      accountType: 'individual',
      errors: {
        email: '',
        mobile: '',
      },
    },
    {
      firstName: 'xyz',
      dob: 'test',
      email: 'xyz@gmail.com',
      countryCode: 'AU(+61)',
      mobile: '7766',
      address: 'street1 2',
      accountType: 'individual',
      errors: {
        email: '',
        mobile: '',
      },
    },
  ]);
  const [signatoryTypeLabel, setSignatoryTypeLabel] = useState(1);
  const [companySecretary, setCompanySecretary] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');
  const [fileFinancialService, setFileFinancialService] = useState(null);
  const [ifApplicable, setIfApplicable] = useState('no');
  const [hasLicense, setHasLicense] = useState('yes');
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [jurisdiction, setJurisdiction] = useState('');
  const [fileAdviceStatement, setFileAdviceStatement] = useState(null);
  const [fileForeignRegistration, setFileForeignRegistration] = useState(null);
  const [fileLicense, setFileLicense] = useState(null);
  const [accountTypeLabel, setAccountTypeLabel] = useState('Individual');
  const [fullName, setFullName] = useState('John Mayer');
  const [formerNames, setFormerNames] = useState('John Mayer');
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState(null);
  const [fileDisclosure, setFileDisclosure] = useState(null);
  const [fileExtractDocument, setFileExtractDocument] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const { showToast } = useToast();
  const [statusData, setStatusData] = useState([]);

  function mapGraphToTree(node) {
    if (!node) return null;

    const relationshipType = node.relationship?.type?.toLowerCase() || 'root';

    const relationshipLabel =
      relationshipType === 'shareholder'
        ? 'Shareholder'
        : relationshipType === 'director'
          ? 'Director'
          : relationshipType === 'trustee'
            ? 'Trustee'
            : relationshipType === 'beneficiary'
              ? 'Beneficiary'
              : relationshipType === 'root'
                ? 'Root entity'
                : relationshipType.charAt(0).toUpperCase() +
                  relationshipType.slice(1);

    return {
      name: node.full_name || 'Unknown',

      type:
        node.entity_type === 'corporate'
          ? 'Corporate'
          : node.entity_type === 'trust'
            ? 'Trust'
            : 'Individual',

      // Display label inside node
      relationship: relationshipLabel,

      // Used for role colours
      relationshipKey: relationshipType,

      ownership: node.relationship?.percentage_ownership,

      meta: {
        relationship: relationshipType,
        ownership: node.relationship?.percentage_ownership,
      },

      children: node.children?.map(mapGraphToTree) || [],
    };
  }
  useEffect(() => {
    if (graphData?.graph) {
      const formatted = [mapGraphToTree(graphData.graph)];
      setTreeData(formatted);
    }
  }, [graphData]);
  const getOwnershipgraph = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/${customerId}/ownership-graph`
          : `/api/v1/agency/customers/${customerId}/ownership-graph`,
      );

      if (response.status == 200) {
        setGraphData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const updateApplication = async (action) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      roleName == 'agent'
        ? action == 'approve'
          ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/approve`
          : action == 'resubmit'
            ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/send-for-resubmission`
            : `${BASE_URL}/api/v1/agent/customers/review/${customerId}/reject`
        : action == 'approve'
          ? `${BASE_URL}/api/v1/agency/customers/review/${customerId}/approve`
          : action == 'resubmit'
            ? `${BASE_URL}/api/v1/agency/customers/review/${customerId}/send-for-resubmission`
            : `${BASE_URL}/api/v1/agency/customers/review/${customerId}/reject`;
    const bodyData = {
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };

          navigate('/customer-list');
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  // const updateSection = async (action, sectionId) => {
  //   const token = localStorage.getItem("jwtToken");
  //   const headers = {
  //     "Content-Type": "application/json",
  //   };

  //   if (token) {
  //     headers.Authorization = `Bearer ${token}`;
  //   }
  //   const apiUrl =
  //     roleName == "agent"
  //       ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/complete-section`
  //       : `${BASE_URL}/api/v1/agency/customers/review/${customerId}/complete-section`;
  //   const bodyData = {
  //     section_id: sectionId,
  //     action: action,
  //     user_id: customerId,
  //   };
  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: "PUT",
  //       headers: headers,
  //       body: JSON.stringify(bodyData),
  //     });

  //     if (!response.ok) {
  //       if (response.status === 401) {
  //         localStorage.removeItem("jwtToken");
  //         navigate("/login");
  //         throw new Error("Session expired. Please log in again.");
  //       }
  //       const errorData = await response.json().catch(() => ({
  //         message: "An unexpected error occurred",
  //       }));

  //       throw new Error(errorData.message || "Something went wrong");
  //     }

  //     return await response.json();
  //   } catch (error) {
  //     throw new Error(error.message || "Network error, please try again later");
  //   }
  // };
  // const handleUpdateSection = useCallback(
  //   debounce(async (action, sectionId) => {
  //     let toastMessage = null;
  //     try {
  //       const response = await updateSection(action, sectionId);
  //       if (response.status == 200) {
  //         toastMessage = {
  //           message: response.message,
  //           type: "success",
  //         };
  //         getStatus();
  //         getAllDetails();
  //       } else {
  //         toastMessage = { message: response.message, type: "error" };
  //       }
  //     } catch (error) {
  //       toastMessage = { message: error.message, type: "error" };
  //     } finally {
  //       setLoadingUpdate(false); // Ensure `loading` is false first
  //       // Show toast after loading is false
  //       if (toastMessage) {
  //         setTimeout(() => {
  //           showToast(toastMessage.message, toastMessage.type);
  //         }, 1000); // Small delay if needed
  //       }
  //     }
  //   }, 1000),
  //   [customerId], // Dependencies
  // );

  // Recursively build nodes & edges from API data
  const [showVisualLink, setShowVisualLink] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenAction(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleCollapseAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = true; // collapsed
    });
    setCollapsedLayers(newState);
  };

  const handleExpandAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = false; // expanded
    });
    setCollapsedLayers(newState);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const mapApiLayersToUiLayers = (apiLayers = []) => {
    return apiLayers.map((layer) => {
      const hasTabs = Array.isArray(layer.tabs);

      // Case 1: entities-based layer (NO tabs)
      if (!hasTabs) {
        return {
          id: layer.layer_number, // ✅ stable key
          layerName: `Interconnection Layer ${layer.layer_number}`,
          hasTabs: false,
          groups: [
            {
              parent: null,
              shareholders: (layer.entities || []).map((e) => ({
                id: e.id,
                name: e.name,
                type: e.shareholder_type?.id || '',
                typeName: e.shareholder_type?.name || '',
                shares: e.percentage_ownership,
                email: e.email,
                userId: e?.shareholder_user_id,
                status: e?.user_status?.name,
                needOnboarding: e.need_onboarding,
                errors: {},
              })),
            },
          ],
        };
      }

      // Case 2: tabs-based layer
      return {
        id: layer.layer_number, // ✅ stable key
        layerName: `Interconnection Layer ${layer.layer_number}`,
        hasTabs: true,
        groups: layer.tabs.map((tab) => ({
          parent: {
            id: tab.parent_id,
            name: tab.parent_name,
          },
          shareholders: (tab.group?.shareholders || []).map((s) => ({
            id: s.id,
            name: s.name,
            type: s.shareholder_type?.id || '',
            typeName: s.shareholder_type?.name || '',
            shares: s.percentage_ownership,
            email: s.email,
            userId: s.shareholder_user_id,
            status: s.user_status?.name,
            needOnboarding: s.need_onboarding,
            errors: {},
          })),
        })),
      };
    });
  };
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year}`;
    } catch (e) {
      return '-';
    }
  }
  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/edd-responses`
          : `/api/v1/agency/customers/review/${customerId}/edd-responses`,
      );
      if (response.status == 200) {
        setEddResponse(response.data);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };
  const sendReverificationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agent/customers/review/${customerId}/request-reverification`;
    // ✅ extract only IDs
    const sectionIds = statusData?.map((section) => section.id) || [];

    const bodyData = {
      sections: sectionIds,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSendReverification = useCallback(
    debounce(async () => {
      let toastMessage = null;
      try {
        const response = await sendReverificationAPI();
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );

  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}`
          : `/api/v1/agency/customers/review/${customerId}`,
      );

      if (response.status == 200) {
        // Open account status
        setFirstNameSignup(
          response.data.open_account_information.first_name.value,
        );
        setLastNameSignup(
          response.data.open_account_information.last_name.value,
        );
        setCustomerStatus(response.data.open_account_information.status.value);
        setEmail(response.data.open_account_information.email_address.value);
        setMobileNumber(
          response.data.open_account_information.country_code.value +
            response.data.open_account_information.mobile_number.value,
        );
        setCustomerType(
          response.data.open_account_information.account_type.value,
        );

        //Corporate information
        setPreview(response.data.corporate_information.company_logo_file);
        setAccountTypeLabel(
          response.data.corporate_information.corporate_type.value.label,
        );
        setAccountType(
          response.data.corporate_information.corporate_type.value.id,
        );
        setFullName(response.data.corporate_information.company_full_name);
        setFormerNames(
          response.data.corporate_information.former_trading_names,
        );
        setBusinessActivity(
          response.data.corporate_information.business_activities,
        );

        const date = new Date(
          response.data.corporate_information.date_of_incorporation.value,
        );
        const formattedDate = date.toLocaleDateString('en-GB');
        setDoI(response.data.corporate_information.date_of_incorporation);
        setFormattedDOI(formattedDate);
        setForeignRegistered(
          response.data.corporate_information.is_registered_foreign_body
            .value == true
            ? 'yes'
            : 'no',
        );
        setEIN(response.data.corporate_information.foreign_ein);
        setCompanyRegistrationNumber(
          response.data.corporate_information.foreign_registration_number,
        );
        if (response.data.corporate_information.corporate_type.value.id != 1) {
          setForeignAddress(
            response.data.corporate_information.country_of_formation_address,
          );
        }
        setCompanyTypeText(
          response.data.corporate_information.registered_by_asic_as,
        );
        setCountryCodeText(
          response.data.corporate_information.country_of_domicile,
        );
        setRegisteredAddress(
          response.data.corporate_information.registered_office_address,
        );
        setPrincipalAddress(
          response.data.corporate_information.principal_place_address,
        );

        if (response.data.corporate_information.corporate_type.value.id == 1) {
          setStateText(
            response.data.corporate_information.state_or_territory_in_aus,
          );
          setAbn(response.data.corporate_information.abn);
          setAcn(response.data.corporate_information.acn);
        }

        setStockRegistered(
          response.data.corporate_information?.is_listed_on_comparable_exchange
            ?.value == true
            ? 'No'
            : 'Yes',
        );
        setStockExchangeText(
          response.data.corporate_information.relevant_stock_exchange,
        );
        setArbn(response.data.corporate_information.arbn);
        setCompanySecretary(
          response.data.corporate_information.company_secretary_name,
        );
        setCompanyWebsite(response.data.corporate_information.company_website);
        // Directors
        setSignatoryTypeLabel(
          response.data.directors_shareholders?.signatory_type,
        );
        setSignatories(response.data.directors_shareholders?.signatories);
        setFileAttorney(
          response.data.directors_shareholders?.board_resolution_file,
        );
        setMembers(
          response.data.directors_shareholders.directors.map((item) => ({
            firstName: item.first_name, // or Date.now() if you want local-only IDs
            lastName: item.last_name,
            countryCode: item.country_code, // 1 = Individual, 2 = Corporate, 3 = Trust
            mobile: item.mobile_number,
            email: item.email,
            status: item.status,
            managingMember: item.is_managing_member,
            userId: item.invitee_user_id,
            needOnboarding: item.need_onboarding,
          })),
        );
        const uiLayers = mapApiLayersToUiLayers(
          response.data.directors_shareholders.shareholders.layers,
        );
        setLayers(uiLayers);
        // Proof docs
        setIfApplicable(
          response.data.corporate_proof_documents.has_prosecution.value,
        );
        setDescription(
          response.data.corporate_proof_documents.prosecution_description,
        );
        setFileProof(
          response.data.corporate_proof_documents.prosecution_document,
        );
        setWebLink(response.data.corporate_proof_documents.website_link);
        setFilePublicDocument(
          response.data.corporate_proof_documents.company_public_document,
        );
        setFileExtractDocument(
          response.data.corporate_proof_documents.asic_search_extract,
        );
        setFileAccountantCertificate(
          response.data.corporate_proof_documents.accountant_certificate,
        );
        setFileCompanyOrganisationalChart(
          response.data.corporate_proof_documents.company_organization_chart,
        );
        setFileIncorporationCertificate(
          response.data.corporate_proof_documents.certificate_of_incorporation,
        );
        let companyCategory =
          response.data.corporate_information.corporate_type.value.id;
        let companyType =
          response.data.corporate_information.registered_by_asic_as.value.id;
        if (
          companyCategory != 1 ||
          (companyCategory == 1 && companyType == 2)
        ) {
          setTicketLink(response.data.corporate_proof_documents.ticket_number);
          setFileTicket(response.data.corporate_proof_documents.asx_document);
        }
        if (
          companyCategory == 2 ||
          (companyCategory == 3 && companyType == 2) ||
          (companyCategory == 1 && companyType == 1)
        ) {
          setFileCompanyRegistration(
            response.data.corporate_proof_documents.registration_certificate,
          );
          setFileDisclosure(
            response.data.corporate_proof_documents
              .beneficial_ownership_certificate,
          );
        }
        setFileShareholderCertificate(
          response.data.corporate_proof_documents.shareholder_certificate,
        );
        if (companyCategory != 1) {
          setFileCertificateOfIncumbency(
            response.data.corporate_proof_documents.certificate_of_incumbency,
          );
          setFileUboCertificate(
            response.data.corporate_proof_documents.ubo_certificate,
          );

          setFileArticle(
            response.data.corporate_proof_documents.articles_of_association,
          );
        }
        if (
          companyCategory == 1 ||
          (companyCategory == 3 && companyType == 1)
        ) {
          const proofDoc = response?.data?.corporate_proof_documents;
          const hasAfsl = proofDoc?.has_afsl.value;
          setHasLicense(hasAfsl);
          if (hasAfsl) {
            setFileLicense(proofDoc?.regulator_license_document);
          }
          setFileThirdParty(
            response.data.corporate_proof_documents.contract_document,
          );
          setThpDescription(
            response.data.corporate_proof_documents.contract_description,
          );
        }
        if (
          companyCategory == 2 ||
          (companyCategory == 3 && companyType == 2)
        ) {
          setFileForeignRegistration(
            response.data.corporate_proof_documents
              .foreign_registration_certificate,
          );
          setJurisdiction(
            response.data.corporate_proof_documents.primary_jurisdiction,
          );

          setFileFinancialService(
            response.data.corporate_proof_documents.afsl_document,
          );
          setFileActivityEvidence(
            response.data.corporate_proof_documents.company_activities_evidence,
          );
          setFileAdviceStatement(
            response.data.corporate_proof_documents.statement_of_advice,
          );
        }
        setVerificationStatus(
          response.data.dvs_checks.latest.verification_result_code,
        );
        setDvsMeessage(
          response.data.dvs_checks.latest.verification_result_message,
        );
        setDvsTime(response.data.dvs_checks.latest.created_at);
        setIsDataAvailable(true);
      }
    } catch (err) {
      setIsDataAvailable(false);
      showToast(err.message, 'error');
    }
  };
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/sections`
          : `/api/v1/agency/customers/review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data.sections);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const getOverallJourney = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/overall-status`
          : `/api/v1/agency/customers/review/${customerId}/overall-status`,
      );
      const stageIconMap = {
        application_submitted: 'description',
        sanction_verification: 'gavel',
        identity_verification: 'verified_user',
        manual_review: 'manage_search',
        approved: 'check_circle',
        rejected: 'cancel',
        resubmission: 'refresh',
      };
      if (response.status == 200) {
        const stages = response.data?.stages || [];

        const mappedStages = stages.map((item) => ({
          ...item,
          key: item.stage,
          icon: stageIconMap[item.stage] || 'circle',
        }));

        setSteps(mappedStages);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
      getOverallJourney();
    }
  }, [customerId, updateFieldStatus]);
  useEffect(() => {
    if (customerId) {
      getEddResponses();
      getOwnershipgraph();
    }
  }, [customerId]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          {' '}
          <div className="w-full relative">
            <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
                <span className="font-medium lg:text-lg text-sm">
                  Review KYC
                </span>
              </div>
            </div>
            <div>
              <div className="flex flex-wrap justify-between p-4  items-center mb-4">
                <div className="flex items-center w-full md:w-auto mb-4 md:mb-0">
                  <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto">
                    <h1 className="text-md font-medium mr-2">
                      {firstNameSignup} {lastNameSignup}
                    </h1>
                  </div>
                </div>
                <div className="flex space-x-2 w-full md:w-auto">
                  <button
                    onClick={() => {
                      setIsActivityLogOpen(true);
                    }}
                    className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
                  >
                    <img
                      src="/backward-10-seconds.svg"
                      alt="Add Icon"
                      className="mr-2"
                    />
                    <span className="inline pr-2">Activity Log</span>
                  </button>
                </div>
              </div>
              {isActivityLogOpen && (
                <ActivityLog
                  onClose={() => setIsActivityLogOpen(false)}
                  customerId={customerId}
                />
              )}
              <div className="w-full  p-4">
                <AuditStepper steps={steps} />
                <div className="w-full mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-6 md:px-7 md:py-7 shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
                  <SectionStatusGrid sections={statusData} />
                </div>
              </div>
            </div>
            {isDataAvailable && (
              <>
                {/* Open Account Information */}
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                    <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                      <div className="flex text-black items-center space-x-2">
                        <img
                          src="/profile-circle-black.svg"
                          alt="User Avatar"
                          className="h-6 w-6 mb-2"
                        />
                        <h1 className="text-md font-medium mb-2">
                          {' '}
                          Open Account Information
                        </h1>
                      </div>
                    </div>
                    {/* Will add popup here */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                      {/* Column 1 */}
                      <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                        <label className="text-sm text-[#A6A6A6]">
                          First Name
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {firstNameSignup}
                        </div>

                        <label className="mt-2 text-sm text-[#A6A6A6]">
                          Last Name
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {lastNameSignup}
                        </div>
                      </div>

                      {/* Column 2 */}
                      <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <label className="text-sm text-[#A6A6A6]">Email</label>
                        <div className="text-sm break-all whitespace-normal max-w-full">
                          {email}
                        </div>

                        <label className="mt-2 text-sm text-[#A6A6A6]">
                          Mobile
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {mobileNumber}
                        </div>
                      </div>

                      {/* Column 3 */}
                      <div className="flex flex-col lg:pt-4 pt-0 px-4">
                        <label className="text-sm text-[#A6A6A6]">
                          Customer Type
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {customerType.name}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End  */}
                {/* Corporate Information */}
                <div className="w-full  p-4">
                  <div className="bg-white border rounded-2xl p-4 mt-4">
                    <div className="flex justify-between items-start border-colour-custom px-4">
                      {/* Left Section: Icon + Heading */}
                      <div className="flex items-center space-x-2">
                        <img
                          src="/briefcase.svg"
                          alt="User Avatar"
                          className="h-6 w-6"
                        />
                        <h1 className="text-xl font-medium">
                          Corporate Information
                        </h1>
                      </div>
                      {/* <div className="p-4">
                      <StatusDropdown
                        value={statusData[0].status}
                        onChange={(val) => {
                          setLoadingUpdate(true);
                          handleUpdateSection(val, statusData[0].id);
                        }}
                      />
                    </div> */}
                    </div>

                    <div className="bg-white pb-4">
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        <div className="flex flex-col px-4 pt-4">
                          {preview.value && (
                            <>
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  Company Logo
                                </label>
                                <StatusButton
                                  status={preview?.status}
                                  count={preview.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      preview,
                                      'Company Logo',
                                      preview?.value?.presigned_url,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                                <img
                                  src={preview?.value?.presigned_url}
                                  alt={`${fullName}`}
                                  className="w-20 h-20 rounded-full object-cover"
                                />
                              </div>
                            </>
                          )}
                          <label
                            htmlFor="companyCategory"
                            className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                          >
                            Company Category
                          </label>

                          <span>{accountTypeLabel}</span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Full Name of the Company
                            </label>
                            <StatusButton
                              status={fullName.status}
                              count={fullName.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  fullName,
                                  'Full Name of the Company',
                                  fullName.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{fullName.value}</span>
                          {formerNames.value &&
                            formerNames.value.length > 0 && (
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  All Other Business Name(s)
                                </label>
                                <StatusButton
                                  status={formerNames.status}
                                  count={formerNames.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      formerNames,
                                      'All Other Business Name(s)',
                                      formerNames.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                            )}
                          <span>
                            {Array.isArray(formerNames?.value)
                              ? formerNames.value.join(', ')
                              : ''}
                          </span>
                        </div>
                        <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Business Activity
                            </label>
                            <StatusButton
                              status={businessActivity.status}
                              count={businessActivity.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  businessActivity,
                                  'Business Activity',
                                  businessActivity?.value?.label,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{businessActivity?.value?.label}</span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Company's Date of Incorporation
                            </label>
                            <StatusButton
                              status={DoI.status}
                              count={DoI.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  DoI,
                                  "Company's Date of Incorporation",
                                  formattedDOI,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{formattedDOI}</span>
                        </div>
                        <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                          {accountType != 1 && (
                            <>
                              {' '}
                              <label
                                htmlFor="clientNo"
                                className="mb-1 text-sm text-[#A6A6A6] whitespace-normal words-break"
                              >
                                Is the company registered by the relevant
                                foreign registration body?
                              </label>
                              <span>{foreignRegistered}</span>
                              {foreignRegistered === 'yes' && (
                                <>
                                  <label
                                    htmlFor="clientNo"
                                    className="mb-1 text-sm mt-4 text-[#A6A6A6] whitespace-normal words-break"
                                  >
                                    Employer Identification Number (EIN)
                                  </label>
                                  <span>{EIN.value}</span>
                                </>
                              )}
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Company registration number
                                </label>
                                <StatusButton
                                  status={companyRegistrationNumber.status}
                                  count={
                                    companyRegistrationNumber.comments?.length
                                  }
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      companyRegistrationNumber,
                                      'Company registration number',
                                      companyRegistrationNumber.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{companyRegistrationNumber.value}</span>
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  The address of the company in its country of
                                  formation, incorporation or registration as
                                  registered by the relevant foreign
                                  registration body
                                </label>
                                <StatusButton
                                  status={foreignAddress.status}
                                  count={foreignAddress.comments?.length}
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      foreignAddress,
                                      "Country of formation's address",
                                      foreignAddress?.value?.google_address,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>
                                {foreignAddress?.value?.google_address}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                        <div className="flex flex-col px-4 pt-4">
                          {(accountType == 1 || accountType == 2) && (
                            <>
                              <label
                                htmlFor="applicantCountry"
                                className="mb-1 text-sm text-[#A6A6A6]"
                              >
                                Registered by ASIC as
                              </label>
                              <span>{companyTypeText?.value?.label}</span>
                            </>
                          )}
                          {accountType == 3 && (
                            <>
                              <label
                                htmlFor="applicantCountry"
                                className="mb-1 text-sm text-[#A6A6A6]"
                              >
                                Type Of Company
                              </label>
                              <span>{companyTypeText.value.label}</span>
                              <label
                                htmlFor="applicantCountry"
                                className="mb-1 text-sm text-[#A6A6A6] mt-4"
                              >
                                Company’s Domicile Country
                              </label>
                              <span>{countryCodeText.value.label}</span>
                            </>
                          )}
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Address of the Company's Registered Office
                            </label>
                            <StatusButton
                              status={registeredAddress.status}
                              count={registeredAddress.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  registeredAddress,
                                  "Address of the Company's Registered Office",
                                  registeredAddress?.value?.google_address,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>
                            {registeredAddress?.value?.google_address}
                          </span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Address of the Company's Principal place of
                              business
                            </label>
                            <StatusButton
                              status={principalAddress.status}
                              count={principalAddress.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  principalAddress,
                                  "Address of the Company's Registered Office",
                                  principalAddress?.value?.google_address,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{principalAddress?.value?.google_address}</span>
                        </div>
                        <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          {accountType == 1 && (
                            <>
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  State or Territory in Australia
                                </label>
                                <StatusButton
                                  status={stateText.status}
                                  count={stateText.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      stateText,
                                      'State or Territory in Australia',
                                      stateText?.value?.label,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{stateText?.value?.label}</span>
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  ABN
                                </label>
                                <StatusButton
                                  status={abn?.status}
                                  count={abn?.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      abn,
                                      'ABN',
                                      abn?.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{abn?.value}</span>
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  ACN
                                </label>
                                <StatusButton
                                  status={acn?.status}
                                  count={acn?.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      acn,
                                      'ACN',
                                      acn?.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{acn?.value}</span>
                            </>
                          )}
                          {accountType == 3 && (
                            <>
                              {' '}
                              <label
                                htmlFor="businessName"
                                className="mb-1 text-sm text-[#A6A6A6] whitespace-normal words-break"
                              >
                                Is your company listed under an Australian
                                Comparable Stock Exchange?
                              </label>
                              <span>{stockRegistered}</span>
                              {stockRegistered == 'Yes' && (
                                <>
                                  <div className="flex mt-2 items-center justify-between">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm text-[#A6A6A6] flex items-center"
                                    >
                                      Relevant Stock Exchange
                                    </label>
                                    <StatusButton
                                      status={stockExchangeText.status}
                                      count={stockExchangeText.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          stockExchangeText,
                                          'Relevant Stock Exchange',
                                          stockExchangeText.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{stockExchangeText.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {accountType != 1 && (
                            <>
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  ARBN
                                </label>
                                <StatusButton
                                  status={arbn.status}
                                  count={arbn.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      arbn,
                                      'ARBN',
                                      arbn.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{arbn.value}</span>
                            </>
                          )}
                        </div>
                        <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              The Name of the Company’s Secretary
                            </label>
                            <StatusButton
                              status={companySecretary.status}
                              count={companySecretary.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  companySecretary,
                                  'The Name of the Company’s Secretary',
                                  companySecretary.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{companySecretary.value}</span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Company Website
                            </label>
                            <StatusButton
                              status={companyWebsite.status}
                              count={companyWebsite.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  companyWebsite,
                                  'Company Website',
                                  companyWebsite.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{companyWebsite.value}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End  */}
                {/* Shareholders and directors section */}
                <div className="w-full  p-4">
                  <div className="bg-white mt-4 border rounded-2xl p-4">
                    <div className="border-b">
                      {/* Header */}
                      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-colour-custom px-4 pb-2 mb-4 gap-2">
                        <div className="flex items-center gap-2">
                          <img
                            src="/people.svg"
                            alt="User Avatar"
                            className="h-6 w-6"
                          />
                          <h1 className="text-xl font-medium">
                            Directors:{' '}
                            <span className="text-[#8C8C8C] font-medium">
                              {firstNameSignup} {lastNameSignup}
                            </span>
                          </h1>
                        </div>
                        {/* <div className="p-4">
                        <StatusDropdown
                          value={statusData[1].status}
                          onChange={(val) => {
                            setLoadingUpdate(true);
                            handleUpdateSection(val, statusData[1].id);
                          }}
                        />
                      </div> */}

                        <div className="flex flex-col sm:flex-row gap-1 sm:gap-2 items-start sm:items-center">
                          <span className="text-sm text-[#A6A6A6]">
                            Number of directors within your organisation:
                          </span>
                          <span className="text-sm font-medium text-black">
                            <div className="font-semibold">
                              <div className="flex items-center text-sm mt-1 md:mt-0 space-x-0 ml-1  bg-white shadow-md">
                                {/* Count display */}
                                <span className="text-sm font-medium bg-gray-400 rounded-lg text-white p-2">
                                  {members.length.toString().padStart(2, '0')}
                                </span>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                      {/* Directors Table */}
                      <div className="overflow-x-auto">
                        <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
                          <thead className="bg-[#F9F9F9] text-[#A6A6A6] font-semibold">
                            <tr>
                              <th className="p-2 w-[40px]"></th>
                              <th className="p-2">First Name</th>
                              <th className="p-2">Last Name</th>
                              <th className="p-2">Email Address</th>
                              <th className="p-2">Mobile Number</th>
                              <th className="p-2">Managing Member</th>
                              <th className="p-2">Status</th>
                              <th className="p-2"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {members.map((member, idx) => (
                              <tr
                                key={idx}
                                className="border-t bg-white align-top"
                              >
                                <td className="p-2 font-medium text-[#A6A6A6]">
                                  {(idx + 1).toString().padStart(2, '0')}.
                                </td>
                                <td className="p-2 font-medium">
                                  <span>{member.firstName}</span>
                                </td>
                                <td className="p-2 font-medium">
                                  <span>{member.lastName}</span>
                                </td>
                                <td className="p-2 font-medium">
                                  <span>{member.email}</span>
                                </td>
                                <td className="p-2 font-medium">
                                  <span>
                                    {member.countryCode} {member.mobile}
                                  </span>
                                </td>
                                <td className="p-2 flex justify-center items-center">
                                  <input
                                    type="radio"
                                    name="managingMember"
                                    value={true}
                                    checked={member.managingMember == true}
                                    disabled={true}
                                    className="w-6 h-4 confirm-check-disabled border-gray-300 focus:ring-[#005a9c]"
                                  />
                                </td>
                                <td className="p-2 font-medium">
                                  <span
                                    className={`px-3 py-1 rounded-full text-xs font-semibold inline-block
      ${
        member.status.name === 'pending' || member.status.name === 'onboarding'
          ? 'bg-yellow-100 text-yellow-800'
          : member.status.name === 'to_review'
            ? 'bg-blue-100 text-blue-800'
            : member.status.name === 'approved' ||
                member.status.name === 'active'
              ? 'bg-green-100 text-green-800'
              : 'bg-gray-100 text-gray-700'
      }
    `}
                                  >
                                    {member.status.label}
                                  </span>
                                </td>
                                <td className="p-2">
                                  {member.status.name != 'pending' &&
                                    member.status.name != 'onboarding' &&
                                    member.needOnboarding && (
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          let redirectState = {
                                            path: `/review-kyc-jointaccount/${member.userId}`,
                                            state: {
                                              from: location.pathname,
                                              historyStack: [
                                                ...(location.state
                                                  ?.historyStack || []),
                                                location.pathname,
                                              ],
                                            },
                                          };
                                          sessionStorage.setItem(
                                            'redirectAfterLogin',
                                            JSON.stringify(redirectState),
                                          );
                                          navigate(
                                            `/review-kyc-jointaccount/${member.userId}`,
                                            {
                                              state: {
                                                from: location.pathname,
                                                historyStack: [
                                                  ...(location.state
                                                    ?.historyStack || []),
                                                  location.pathname,
                                                ],
                                              },
                                            },
                                          );
                                        }}
                                        className="px-3 py-1 rounded-lg  border bg-[#D3D3D3] text-[#9C9C9C] font-medium"
                                      >
                                        View Application
                                      </button>
                                    )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {/* Signatory Section */}
                      {members.length > 0 && (
                        <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
                          {/* Signatory Type */}
                          <div className="flex flex-col px-2 pt-4">
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Signatory Type
                              </label>
                              <StatusButton
                                status={signatoryTypeLabel.status}
                                count={signatoryTypeLabel.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    signatoryTypeLabel,
                                    'Signatory Type',
                                    signatoryTypeLabel?.value?.label,
                                    '',
                                  )
                                }
                              />
                            </div>
                            <span>{signatoryTypeLabel?.value?.label}</span>
                          </div>

                          {/* Signatories */}
                          <div className="flex flex-col px-2 pt-4 border-t md:border-t-0 md:border-l border-gray-300">
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Signatory/Signatories
                              </label>
                              <StatusButton
                                status={signatories.status}
                                count={signatories.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    signatories,
                                    'Signatory/Signatories',
                                    signatories?.value?.google_address,
                                    '',
                                  )
                                }
                              />
                            </div>
                            <span>{signatories.value}</span>
                          </div>

                          {/* File Upload */}
                          <div className="flex flex-col px-2 pt-4">
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Board Resolution
                              </label>
                              <StatusButton
                                status={fileAttorney?.status}
                                count={fileAttorney?.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    fileAttorney,
                                    'Board Resolution',
                                    fileAttorney?.value,
                                    'file',
                                  )
                                }
                              />
                            </div>
                            {fileAttorney && fileAttorney.value && (
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(fileAttorney.value);
                                }}
                                className="underline cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                              >
                                <div className="flex-col flex">
                                  <span className="text-black">
                                    {fileAttorney.value.file_name}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="bg-white rounded-2xl mt-4">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-2 md:space-y-0 px-2">
                        <div className="flex items-center space-x-2">
                          <img
                            src="/people.svg"
                            alt="User Avatar"
                            className="h-6 w-6"
                          />
                          <h1 className="text-xl font-medium">
                            Shareholders:
                            <span className="text-xl font-medium text-[#8C8C8C] ml-1">
                              {firstNameSignup} {lastNameSignup}
                            </span>
                          </h1>
                        </div>
                        <div className="flex space-x-2">
                          <button
                            onClick={() => {
                              setShowVisualLink(true);
                            }}
                            className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                          >
                            <img
                              src="/hashtag.svg"
                              alt="Collapse Icon"
                              className="w-4 h-4 flex-shrink-0"
                            />
                            <span className="font-medium">Visual Link</span>
                          </button>
                          <button
                            onClick={handleCollapseAll}
                            className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                          >
                            <img
                              src="/arrow-square-up.svg"
                              alt="Collapse Icon"
                              className="w-4 h-4 flex-shrink-0"
                            />
                            <span className="font-medium">Collapse All</span>
                          </button>
                          <button
                            onClick={handleExpandAll}
                            className="bg-[#375AE7] text-white text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                          >
                            <img
                              src="/arrow-square-down.svg"
                              alt="Collapse Icon"
                              className="w-4 h-4 flex-shrink-0"
                            />
                            <span className="font-medium">Expand All</span>
                          </button>
                        </div>
                      </div>
                      {showVisualLink && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[99999]">
                          <div className="relative bg-white rounded-2xl shadow-2xl w-[95%] md:w-[900px] p-6">
                            {/* Close Button */}
                            <button
                              onClick={() => setShowVisualLink(false)}
                              className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl font-bold transition-colors"
                            >
                              &times;
                            </button>

                            {/* Graph */}
                            <div className="mt-6 w-full h-[500px] border border-gray-200 rounded-xl overflow-hidden">
                              <MindmapTree data={treeData} />
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="pt-2">
                        {layers.map((layer) => (
                          <ShareholderLayer
                            key={layer.id}
                            layer={layer}
                            collapsed={collapsedLayers[layer.id] ?? false}
                            onToggle={() =>
                              setCollapsedLayers((prev) => ({
                                ...prev,
                                [layer.id]: !prev[layer.id],
                              }))
                            }
                          />
                        ))}
                      </div>
                    </div>
                  </div>{' '}
                </div>
                {/* Upload Proof Documents */}
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                    <div className="flex flex-wrap md:flex-nowrap items-center justify-between border-colour-custom pt-2 px-4 gap-4">
                      {/* Left Section (Title + Icon) */}
                      <div className="flex text-black items-center space-x-2">
                        <img
                          src="/note-2.svg"
                          alt="User Avatar"
                          className="h-6 w-6"
                        />
                        <h1 className="text-md font-medium">
                          Upload Proof Documents
                        </h1>
                      </div>
                      {/* <div className="p-4">
                        <StatusDropdown
                          value={statusData[2].status}
                          onChange={(val) => {
                            setLoadingUpdate(true);
                            handleUpdateSection(val, statusData[2].id);
                          }}
                        />
                      </div> */}
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6  pb-2">
                      {/* first column */}
                      <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                        {(accountType != 1 ||
                          (accountType == 1 && companyTypeText.id == 2)) && (
                          <>
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6]  whitespace-normal break-words block"
                              >
                                A search/extract of the relevant Australian
                                stock exchange
                              </label>
                            </div>
                            {ticketLink?.value != '' && (
                              <>
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6]  whitespace-normal break-words block"
                                >
                                  Ticket Number
                                </label>
                                <span>{ticketLink?.value}</span>
                              </>
                            )}
                            {fileTicket && fileTicket.value && (
                              <>
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6]  whitespace-normal break-words block"
                                >
                                  Uploaded File
                                </label>
                                <div
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileClick(fileTicket.value);
                                  }}
                                  className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                                >
                                  <div className="flex-col flex">
                                    <span className="text-black">
                                      {fileTicket?.value?.file_name}
                                    </span>
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="A public document issued by the company (E.g. Annual
                            General Report)"
                                fileData={filePublicDocument}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        {(accountType == 2 ||
                          (accountType == 3 && companyTypeText.id == 2) ||
                          (accountType == 1 && companyTypeText.id == 1)) && (
                          <>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label={
                                  accountType == 2
                                    ? 'Valid Company Registration Certificate issued by ASIC'
                                    : 'Valid Company Registration Certificate'
                                }
                                fileData={fileCompanyRegistration}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Disclosure certificate verifying information about the
                      beneficial ownership of the company"
                                fileData={fileDisclosure}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="Shareholder Certificate"
                            fileData={fileShareholderCertificate}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="A search/extract of the relevant ASIC database"
                            fileData={fileExtractDocument}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        {accountType != 1 && (
                          <div className="mt-4">
                            <FileUploadDisplay
                              label="Certificate of Incumbency"
                              fileData={fileCertificateOfIncumbency}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                      </div>
                      {/* second column */}
                      <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                        {(accountType == 1 ||
                          (accountType == 3 && accountType == 1)) && (
                          <>
                            {' '}
                            <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                              <label
                                htmlFor="investmentType"
                                className="[#A6A6A6] block whitespace-normal break-words text-sm text-[#A6A6A6] flex items-center"
                              >
                                Does your company possess a financial services
                                license?
                              </label>
                              <div className="flex items-center gap-4 opacity-50 ">
                                <label className="flex items-center text-sm text-black">
                                  <input
                                    type="radio"
                                    name="hasLicense"
                                    value={true}
                                    checked={hasLicense === true}
                                    disabled={true}
                                    className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                                  />
                                  <span className="ml-2">Yes</span>
                                </label>
                                <label className="flex items-center text-sm text-black">
                                  <input
                                    type="radio"
                                    name="hasLicense"
                                    value={false}
                                    checked={hasLicense === false}
                                    disabled={false}
                                    className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                                  />
                                  <span className="ml-2">No</span>
                                </label>
                              </div>
                              {hasLicense && (
                                <>
                                  <div>
                                    <FileUploadDisplay
                                      label="Upload a search of the license or other
                                  records of the relevant commonwealth, state,
                                  or Territory regulator"
                                      fileData={fileLicense}
                                      onFileClick={handleFileClick}
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {(accountType == 2 ||
                          (accountType == 3 && accountType == 2)) && (
                          <>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Valid company registration certificate issued by the
                            relevant foreign registration body"
                                fileData={fileForeignRegistration}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <label
                              htmlFor="firstName"
                              className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                            >
                              Jurisdiction of the primary operations of the
                              company
                            </label>
                            <span>{jurisdiction?.value}</span>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Valid Australian financial services license issued
                            by ASIC"
                                fileData={fileFinancialService}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        <label
                          htmlFor="investmentType"
                          className="block whitespace-normal break-words text-sm text-[#A6A6A6] flex items-center mt-4"
                        >
                          If applicable, description and proof of any current or
                          recent prosecutions and inquiries related to money
                          laundering, terrorist links, tax offenses, and
                          corruption{' '}
                        </label>
                        <div className="flex items-center gap-4 opacity-50 ">
                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value={true}
                              checked={ifApplicable === true}
                              disabled={true}
                              className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                            />
                            <span className="ml-2">Yes</span>
                          </label>
                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value={false}
                              checked={ifApplicable === false}
                              disabled={false}
                              className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                            />
                            <span className="ml-2">No</span>
                          </label>
                        </div>
                        {ifApplicable && (
                          <>
                            <div className="mt-4">
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  Description
                                </label>
                                <StatusButton
                                  status={description?.status}
                                  count={description?.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      description,
                                      'Description',
                                      description?.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{description.value}</span>
                            </div>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Upload Proof"
                                fileData={fileProof}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        {accountType != 1 && (
                          <div className="mt-4">
                            <FileUploadDisplay
                              label="UBO Certificate"
                              fileData={fileUboCertificate}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                      </div>
                      {/* third column */}
                      <div className="flex flex-col pr-4 pt-4">
                        {(accountType == 1 || accountType == 3) && (
                          <>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Contracts with third parties to verify the intended
                            transaction"
                                fileData={fileThirdParty}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <div className="mt-4">
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  Description
                                </label>
                                <StatusButton
                                  status={thpDescription?.status}
                                  count={thpDescription?.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      thpDescription,
                                      'Description',
                                      thpDescription?.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{thpDescription.value}</span>
                            </div>
                          </>
                        )}
                        {(accountType == 2 ||
                          (accountType == 3 && accountType == 2)) && (
                          <>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Evidence about the activities undertaken by the
                            company"
                                fileData={fileActivityEvidence}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Statement of Advise"
                                fileData={fileAdviceStatement}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        <div className="mt-4">
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Webiste Link
                            </label>
                            <StatusButton
                              status={webLink?.status}
                              count={webLink?.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  webLink,
                                  'Webiste Link',
                                  webLink?.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{webLink?.value}</span>
                        </div>
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="Accountant Certificate"
                            fileData={fileAccountantCertificate}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="Certificate of incorporation"
                            fileData={fileIncorporationCertificate}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="Company Organisational Chart"
                            fileData={fileCompanyOrganisationalChart}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        {accountType != 1 && (
                          <div className="mt-4">
                            <FileUploadDisplay
                              label="Articles of Association/Constitution"
                              fileData={fileArticle}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* End  */}
              </>
            )}
            <div className="w-full  p-4">
              <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                {/* <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                  <div className="flex text-black items-center space-x-2">
                    <img
                      src="/profile-circle-black.svg"
                      alt="User Avatar"
                      className="h-6 w-6 mb-2"
                    />
                    <h1 className="text-md font-medium mb-2"> Scan Results</h1>
                  </div>
                  <div className="p-4">
                    <button
                      onClick={() => setShowModal(true)}
                      className="ml-3 bg-[#375AE7] text-sm text-white px-4 py-2 rounded-lg hover:bg-[#2f4ed8] transition"
                    >
                      Start ECDD Check
                    </button>
                  </div>
                </div> */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                  {/* Column 1 */}
                  <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                    <label className="text-sm text-[#A6A6A6]">
                      Verification Status
                    </label>
                    <div className="text-sm break-words max-w-full">
                      <button
                        className={` w-40 mt-1 text-left cursor-text font-medium  rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                          verificationStatus?.code == 'Y'
                            ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                            : ''
                        }
                                  ${
                                    verificationStatus?.code == 'N'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
  
                              `}
                      >
                        <span className="mr-6 text-left">
                          {verificationStatus?.label}
                        </span>
                      </button>
                    </div>

                    <label className="mt-2 text-sm text-[#A6A6A6]">Date</label>
                    <div className="text-sm break-words max-w-full">
                      {formatDateTimeUTC(dvsTime)}
                    </div>
                  </div>

                  {/* Column 2 */}
                  <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l border-gray-300 px-4">
                    <label className="text-sm text-[#A6A6A6]">Message</label>
                    <div className="text-sm break-all whitespace-normal max-w-full">
                      {dvsMeessage}
                    </div>
                  </div>

                  {/* Column 3 */}
                  <div className="flex flex-col lg:pt-4 pt-0 px-4"></div>
                </div>
              </div>
            </div>
            {(pendingQuestions.length > 0 || completedGroups.length > 0) && (
              <div className="bg-white rounded-2xl p-4">
                <div className="bg-white border rounded-2xl p-4 mt-4">
                  {pendingQuestions.length > 0 && (
                    <div className="w-full p-4">
                      <UserQuestionnaire
                        apidata={pendingQuestions}
                        customerName={firstNameSignup + ' ' + lastNameSignup}
                        isPending={true}
                        heading={'Customer Submitted ECDD Responses'}
                      />
                    </div>
                  )}
                  {completedGroups.length > 0 && (
                    <div className="w-full p-4">
                      <UserQuestionnaire
                        apidata={completedGroups}
                        customerName={firstNameSignup + ' ' + lastNameSignup}
                        isPending={false}
                        heading={'Customer Submitted ECDD Responses'}
                      />
                    </div>
                  )}{' '}
                </div>
              </div>
            )}
            <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
              {/* Right Section: Download Button */}
              <div className="flex items-center justify-end w-full">
                {customerStatus != 'active' && (
                  <div ref={dropdownRef} className="relative inline-block mr-4">
                    {/* Button */}
                    <div
                      className="flex text-sm justify-between items-center py-2 px-2 border border-white  w-40 rounded-full cursor-pointer"
                      onClick={() => setIsOpenAction(!isOpenAction)}
                    >
                      <span className="text-right pl-4 text-white">
                        Actions
                      </span>
                      <span className="text-gray-500">
                        {' '}
                        <img
                          src="/white-dropdown.svg"
                          alt="document-download"
                          className="pr-2"
                        />
                      </span>
                    </div>

                    {/* Dropdown Menu */}
                    {isOpenAction && (
                      <div className="absolute text-xs top-[-250%] right-0 bg-white text-black shadow-lg rounded-md w-40 p-2 z-10">
                        <ul>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'approve');
                            }}
                            className="p-2 hover:bg-[#375AE7] hover:text-white cursor-pointer"
                          >
                            Approve Application
                          </li>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'reject');
                            }}
                            className="p-2 hover:bg-[#375AE7] text-[#FF5050] hover:text-[#FF5050] cursor-pointer"
                          >
                            Reject Application
                          </li>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'resubmit');
                            }}
                            className="p-2 hover:bg-[#375AE7] text-black hover:text-white cursor-pointer"
                          >
                            Send for resubmit
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                )}
                {customerStatus == 'active' && (
                  <div ref={dropdownRef} className="relative inline-block mr-4">
                    {/* Button */}
                    <div
                      className="flex text-sm border border-white py-2 w-40 rounded-full cursor-pointer"
                      onClick={() => {
                        setLoadingUpdate(true);
                        handleSendReverification();
                      }}
                    >
                      <span className="text-right pl-4 text-white">
                        Send for resubmit
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {showModal && (
              <EDDModal
                pendingQuestions={pendingQuestions}
                completedQuestions={completedQuestions}
                closeModal={() => {
                  setShowModal(false);
                  getEddResponses();
                }}
              />
            )}
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={currentDocument.presigned_url}
                fileName={currentDocument.file_name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
            {showPopup && currentField && (
              <ReviewPopupKYC
                isOpen={showPopup}
                currentField={currentField}
                currentFieldName={currentFieldName}
                currentFieldValue={currentFieldValue}
                currentFieldType={currentFieldType}
                onClose={() => setShowPopup(false)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};
const ShareholderLayer = ({ layer, collapsed, onToggle }) => {
  const { layerName, groups, hasTabs } = layer;
  const isOpen = !collapsed;
  const navigate = useNavigate();
  const location = useLocation();
  const { customerId } = useParams();

  const [activeTab, setActiveTab] = useState(0);
  const rowsToRender = hasTabs
    ? groups[activeTab]?.shareholders || []
    : groups[0]?.shareholders || [];

  useEffect(() => {
    setActiveTab(0);
  }, [groups]);

  return (
    <div className="border rounded-2xl shadow-sm bg-white mb-6">
      {/* Header */}
      <div
        onClick={onToggle}
        className="bg-[#464646] text-white px-4 py-2 rounded-t-2xl flex justify-between items-center cursor-pointer"
      >
        <h2 className="text-sm font-medium">{layerName}</h2>
        <span className="text-lg">{isOpen ? '−' : '+'}</span>
      </div>

      {isOpen && (
        <>
          {/* Tabs ONLY when groups > 1 */}
          {hasTabs && (
            <div className="flex border-b">
              {groups.map((g, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  className={`px-4 py-2 text-sm font-medium ${
                    activeTab === idx
                      ? 'bg-[#375AE7] text-white'
                      : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  {g.parent?.name}
                </button>
              ))}
            </div>
          )}

          {/* Table */}
          <div className="p-4 border rounded-b-lg">
            <div className="overflow-x-auto">
              <table className="w-full text-sm  text-[#8C8C8C]">
                <thead>
                  <tr className="border">
                    <th className="p-2"></th>
                    <th className="p-2 text-left font-medium">
                      Shareholder Name
                    </th>
                    <th className="p-2 text-left font-medium">Type</th>
                    <th className="p-2 text-left font-medium">Shares(%)</th>
                    <th className="p-2 text-left font-medium">Email</th>
                    <th className="p-2 text-left font-medium">
                      User Registration
                    </th>
                    <th className="p-2 text-left font-medium">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {rowsToRender.map((s, idx) => (
                    <tr key={s.id} className="border-t font-medium text-black">
                      <td className="p-2 text-[#8C8C8C]">
                        {String(idx + 1).padStart(2, '0')}.
                      </td>
                      <td className="p-2">{s.name}</td>
                      <td className="p-2">{s.typeName}</td>
                      <td className="p-2">{s.shares}</td>
                      <td className="p-2">{s.email}</td>
                      <td className="p-2">
                        {s.shares >= 25 && s.needOnboarding ? (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              let redirectState = {
                                path:
                                  s.type == 1
                                    ? `/review-kyc-jointaccount/${s.userId}`
                                    : s.type == 2
                                      ? `/review-kyc-corporate-shareholder/${s.userId}`
                                      : `/review-kyc-trust-shareholder/${s.userId}/${customerId}`,
                                state: {
                                  from: location.pathname,
                                  historyStack: [
                                    ...(location.state?.historyStack || []),
                                    location.pathname,
                                  ],
                                },
                              };
                              sessionStorage.setItem(
                                'redirectAfterLogin',
                                JSON.stringify(redirectState),
                              );
                              navigate(
                                s.type == 1
                                  ? `/review-kyc-jointaccount/${s.userId}`
                                  : s.type == 2
                                    ? `/review-kyc-corporate-shareholder/${s.userId}`
                                    : `/review-kyc-trust-shareholder/${s.userId}/${customerId}`,
                                {
                                  state: {
                                    from: location.pathname,
                                    historyStack: [
                                      ...(location.state?.historyStack || []),
                                      location.pathname,
                                    ],
                                  },
                                },
                              );
                            }}
                            className="px-3 py-1 rounded-lg  border bg-[#D3D3D3] text-[#9C9C9C] font-medium"
                          >
                            View Application
                          </button>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </td>

                      <td className="p-2 font-medium">
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-semibold inline-block
      ${
        s.status === 'pending' || s.status === 'onboarding'
          ? 'bg-yellow-100 text-yellow-800'
          : s.status === 'to_review'
            ? 'bg-blue-100 text-blue-800'
            : s.status === 'approved' || s.status === 'active'
              ? 'bg-green-100 text-green-800'
              : 'bg-gray-100 text-gray-700'
      }
    `}
                        >
                          {s.status
                            ?.replaceAll('_', ' ')
                            ?.replace(/\b\w/g, (c) => c.toUpperCase())}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ReviewKYCCorporate;
